<template>
  <div :class="['overall-ratings',isSelectedSchoolPK?'pk':'',loading?'calculating-layout':'']">
    <template v-if="!isSelectedSchoolPK">
      <div class="column logo-desc before">
        <ImgFrameworkLogo/>
        <div class="desc-key">
          <div class="framework-desc">
            <h4>Framework for Great Schools</h4>
            <p>Research shows that schools strong in the six areas are far more likely to improve student learning.</p>
          </div>
        </div>
      </div>
      <div class="column left ratings">
        <div class="heading-wrapper">
          <h3>Overall School Ratings</h3>
        </div>
        <FrameworkRatings/>
        <FrameworkRatingsLegend/>
      </div>
      <div class="column right logo-desc after">
        <ImgFrameworkLogo/>
        <div class="desc-key">
          <div class="framework-desc">
            <h4>Framework for Great Schools</h4>
            <p>Research shows that schools strong in the six areas are far more likely to improve student learning.</p>
          </div>
          <FrameworkRatingsLegend/>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="column left pk-framework">
        <h3>Framework for Great Schools</h3>
        <div class="pk-framework-content">
          <ImgFrameworkLogo/>
          <div class="framework-desc">
            <p>Research shows that schools strong in the six areas are far more likely to improve student learning.</p>
            <p class="instructions tabs">The tabs below provide information on this program in these six areas.</p>
            <p class="instructions menu">Please select a Framework element from the menu above for more information on this program.</p>
          </div>
        </div>
      </div>
      <div class="column right pk-legend">
        <DivPrintableBackground class="pk-legend-wrapper">
          <div class="pk-legend-content">
            <h4>How to Read the Ratings</h4>
            <p>Ratings are shown on a scale of 1 to 4. You can interpret these ratings using this key:</p>
            <FrameworkRatingsLegend/>
          </div>
        </DivPrintableBackground>
      </div>
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'

import { NS_CURRENT_REPORT } from './const'

import DivPrintableBackground from '@/components/DivPrintableBackground'
import ImgFrameworkLogo from '@/components/ImgFrameworkLogo'
import FrameworkRatings from './FrameworkRatings'
import FrameworkRatingsLegend from './FrameworkRatingsLegend'

@Component({
  computed: {
    ...mapGetters(NS_CURRENT_REPORT, [
      'isSelectedSchoolPK'
    ])
  },
  components: {
    DivPrintableBackground,
    ImgFrameworkLogo,
    FrameworkRatings,
    FrameworkRatingsLegend
  }
})
export default class OverallRatings extends Vue {
  loading = true // true on startup

  /* Lifecycle */

  mounted () {
    this.loading = false
  }
  updated () {
    this.loading = false
  }

  /* Watchers */

  @Watch('isSelectedSchoolPK')
  onSchoolChange (newVal, oldVal) {
    this.loading = true
  }
}
</script>

<style lang="scss">
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import 'src/styles/const.scss';
@import './css/const.scss';
$logo-size: 240px;
.overall-ratings {
  display: flex;
  margin-bottom: 32px;
  > * {
    flex: 1;
  }
  &.calculating-layout {
    .column.ratings {
      .framework-ratings-legend {
        visibility: hidden;
      }
    }
  }
  &:not(.calculating-layout) {
    .column.ratings {
      .framework-ratings-legend {
        display: none;
      }
    }
  }
}
h3, h4 {
  margin-top: 0px;
}
.img-framework-logo {
  width: $logo-size;
  height: $logo-size;
  margin-right: 24px;
}
.column {
  padding: 0px;
  margin: 0px 24px;
}
.column.left {
  margin-right: 12px;
}
.column.right {
  margin-left: 12px;
}
.column.logo-desc {
  display: flex;
  height: $logo-size;
  padding-top: 44px;
  .desc-key {
    min-width: 130px;
    max-width: 180px;
    position: relative;
    .framework-ratings-legend {
      position: absolute;
      bottom: 0px;
    }
  }
}
.column.logo-desc.before {
  margin-bottom: 20px;
  .desc-key {
    flex: 1;
  }
}
.pk-framework-content {
  display: flex;
  > * {
    flex: 1;
  }
  .framework-desc {
    padding-top: 20px;
  }
  .instructions {
    margin-top: 4em;
    color: #2d89a0;
    &.menu {
      display: none;
    }
  }
}
.column.pk-legend {
  position: relative;
  .pk-legend-wrapper {
    position: absolute;
    max-width: 400px;
    bottom: 0px;
    right: 0px;
    background-color: #eeeeee;
    border-color: #eeeeee;
  }
  .pk-legend-content {
    padding: 16px;
    h4 {
      color: #777777;
    }
    .framework-ratings-legend {
      padding-left: 60px;
    }
  }
}

/* Responsive rules */

.column.logo-desc.before {
  display: none;
}

@media screen and (max-width: $screen-width-2-column-large) {
  /* Hide legend in right column */
.overall-ratings:not(.pk) {
  &.calculating-layout {
    .column.logo-desc .framework-ratings-legend {
      visibility: hidden;
    }
  }
  &:not(.calculating-layout) {
    .column.logo-desc .framework-ratings-legend {
      display: none;
    }
  }
}
  /* Show legend in left column */
.overall-ratings:not(.pk) {
  .column.ratings .framework-ratings-legend {
    display: flex;
  }
}
.column.ratings .framework-ratings-legend {
  width: 100%;
  box-sizing: border-box;
  /deep/ .title {
    margin-right: 24px;
  }
  /deep/ .legend-items {
    flex: 1;
    display: flex;
  }
  /deep/ .legend-item {
    padding-right: 24px;
    &:last-child {
      padding-right: 10px;
    }
    > * {
      display: block;
    }
  }
}
.column.logo-desc {
  padding-top: 0px;
}
.column.logo-desc.after {
  display: block;
  > * {
    margin-left: auto;
    margin-right: auto;
  }
  .desc-key {
    min-width: 0px;
    max-width: none;
    margin-top: 10px;
  }
}
.pk-framework-content {
  display: block;
  > * {
    margin: auto;
  }
  .framework-desc {
    padding-top: 0px;
  }
}
}
@media screen and (max-width: $medium-screen-width) {
.column.ratings .framework-ratings-legend {
  /deep/ .legend-items {
    justify-content: space-between;
  }
  /deep/ .legend-item {
    padding-right: 0px;
  }
}
}
@media screen and (max-width: $screen-width-2-column-small) {
.column.left {
  margin-left: 10px;
}
.column.right {
  margin-right: 10px;
}
.overall-ratings:not(.pk) {
  .column.ratings .framework-ratings-legend {
    display: block;
  }
}
.pk-framework-content .instructions {
  &.tabs {
    display: none;
  }
  &.menu {
    display: block;
  }
}
}
@media screen and (max-width: $screen-width-1-column-large) {
.column.logo-desc.before {
  display: flex;
  height: auto;
  .desc-key {
    min-width: 0px;
    max-width: none;
  }
}
.overall-ratings {
  &.calculating-layout {
    .column.logo-desc.after {
      visibility: hidden;
    }
  }
  &:not(.calculating-layout) {
    .column.logo-desc.after {
      display: none;
    }
  }
}
.overall-ratings {
  display: block;
  > .column {
    max-width: $max-width-1-col;
    margin: auto;
  }
}
.overall-ratings:not(.pk) {
  .column.ratings .framework-ratings-legend {
    display: flex;
  }
}
.column.pk-legend {
  .pk-legend-wrapper {
    position: relative;
    margin: auto;
  }
}
.column.ratings .framework-ratings-legend {
  /deep/ .legend-items {
    justify-content: flex-start;
  }
  /deep/ .legend-item {
    padding-right: 24px;
  }
}
.pk-framework-content .instructions {
  margin-top: 1em;
}
}
@media screen and (max-width: $screen-width-1-column-medium) {
.overall-ratings {
  > .column {
    max-width: none;
    margin: 0px 10px;
  }
}
}
@media screen and (max-width: $screen-width-1-column-small) {
.column.logo-desc.before {
  display: block;
  > * {
    margin: auto;
  }
  .desc-key {
    margin-top: 10px;
  }
}
.overall-ratings:not(.pk) {
  .column.ratings .framework-ratings-legend {
    display: block;
  }
}
.column.ratings .framework-ratings-legend {
  /deep/ .legend-items {
    justify-content: space-between;
  }
  /deep/ .legend-item {
    padding-right: 0px;
  }
}
}
@media screen and (max-width: 370px) {
.column.ratings {
  margin: 0px;
  .heading-wrapper {
    margin: 0px 10px;
  }
  .framework-ratings-legend {
    padding: 0px 10px;
    /deep/ .legend-item:last-child {
      padding-right: 0px;
    }
  }
}
}
</style>



// WEBPACK FOOTER //
// src/components/sqs/2017/OverallRatings.vue